function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 22.75C6.07 22.75 1.25 17.93 1.25 12S6.07 1.25 12 1.25 22.75 6.07 22.75 12 17.93 22.75 12 22.75zm0-20C6.9 2.75 2.75 6.9 2.75 12S6.9 21.25 12 21.25s9.25-4.15 9.25-9.25S17.1 2.75 12 2.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 16.75c-1.79 0-3.25-1.46-3.25-3.25 0-3.45 2.8-6.25 6.25-6.25 1.79 0 3.25 1.46 3.25 3.25 0 3.45-2.8 6.25-6.25 6.25zm3-8c-2.62 0-4.75 2.13-4.75 4.75 0 .96.79 1.75 1.75 1.75 2.62 0 4.75-2.13 4.75-4.75 0-.96-.79-1.75-1.75-1.75z"
})));